"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var BotActions_1 = require("@src/actions/BotActions");
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var utils_1 = require("@src/utils");
var DomainAPI_1 = require("@src/api/DomainAPI");
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var store_1 = __importDefault(require("@src/store"));
var DomainActions_1 = require("@src/actions/DomainActions");
var dispatcher_1 = require("@src/dispatcher");
var MogamboConstants_2 = require("@src/constants/MogamboConstants");
var utils_2 = require("./utils");
var constants_1 = require("../BusinessManagerV2/containers/ContentManagement/constants");
var WebGuide_1 = __importDefault(require("../WebGuide/WebGuide"));
var StyledComponets_1 = require("../WebGuide/components/StyledComponets");
var WebGuideSwitch = function () {
    var _a;
    var _b = react_router_dom_1.useParams(), businessIdentifier = _b.businessIdentifier, botId = _b.botId;
    var _c = react_1["default"].useState(false), loading = _c[0], setLoading = _c[1];
    var _d = react_1["default"].useState(''), trainingUrl = _d[0], setTrainingUrl = _d[1];
    var _e = react_1["default"].useState(''), zipFolderUrl = _e[0], setZipFolderUrl = _e[1];
    var _f = react_1["default"].useState(true), isZipFolderValidated = _f[0], setIsZipFolderValidated = _f[1];
    var _g = react_1["default"].useState(''), savedZipFolderLink = _g[0], setSavedZipFolderLink = _g[1];
    var _h = react_1["default"].useState(''), zipFolderSavedBy = _h[0], setZipFolderSavedBy = _h[1];
    var _j = react_1["default"].useState(false), documentsUploading = _j[0], setDocumentsUploading = _j[1];
    var _k = react_1["default"].useState(5), followupDelay = _k[0], setFollowupDelay = _k[1];
    var _l = react_1["default"].useState(false), followupEnabled = _l[0], setFollowupEnabled = _l[1];
    var _m = react_1["default"].useState(false), isEdit = _m[0], setIsEdit = _m[1];
    var _o = react_1["default"].useState(false), translateLoading = _o[0], setTranslateLoading = _o[1];
    var _p = react_1["default"].useState(true), followupMessageResponseSaved = _p[0], setFollowupMessageResponseSaved = _p[1];
    var _q = react_1["default"].useState({}), followUpMessage = _q[0], setFollowUpMessage = _q[1];
    var _r = react_1["default"].useState(constants_1.DEFAULTS.CHANNEL_ID), currentChannelId = _r[0], setCurrentChannelId = _r[1];
    var _s = react_1["default"].useState(constants_1.DEFAULTS.CHANNEL_NAME), currentChannelName = _s[0], setCurrentChannelName = _s[1];
    var _t = react_1["default"].useState(constants_1.DEFAULTS.LANGUAGE), currentLanguageCode = _t[0], setCurrentLanguageCode = _t[1];
    var _u = react_1["default"].useState(constants_1.DEFAULTS.LANGUAGE), currentHybridLanguageCode = _u[0], setCurrentHybridLanguageCode = _u[1];
    var _v = react_1["default"].useState([]), allLanguages = _v[0], setAllLanguages = _v[1];
    var _w = react_1["default"].useState([]), platformIdsPresent = _w[0], setPlatformIdsPresent = _w[1];
    var _x = react_1["default"].useState({}), dpsvChannels = _x[0], setDpsvChannels = _x[1];
    var convertResponseFromGetAPI = function (followUpWebGuideRes) {
        var convertedRes = {};
        var languagePlatformsMapping = {};
        Object.entries(followUpWebGuideRes).forEach(function (_a) {
            var langSrc = _a[0], langData = _a[1];
            Object.entries(langData).forEach(function (_a) {
                var _b;
                var langScript = _a[0], scriptData = _a[1];
                var variants = scriptData.variants;
                var platformData = scriptData.device_platform_map;
                languagePlatformsMapping = __assign(__assign({}, languagePlatformsMapping), (_b = {}, _b[langSrc + "|" + langScript] = Object.keys(platformData), _b));
                var key = langSrc + "|" + langScript;
                if (!convertedRes[key]) {
                    convertedRes[key] = {};
                }
                Object.entries(platformData).forEach(function (_a) {
                    var platform = _a[0];
                    convertedRes[key][platform] = (platformData[platform] || []).map(function (id) { return variants[id]; });
                });
            });
        });
        setPlatformIdsPresent((dpsvChannels === null || dpsvChannels === void 0 ? void 0 : dpsvChannels[currentLanguageCode + "|" + currentHybridLanguageCode]) ||
            []);
        setDpsvChannels(languagePlatformsMapping);
        return convertedRes;
    };
    var setFollowUpMessageResponse = function (res) {
        var webguide_follow_up_msgs = res.webguide_follow_up_msgs, webguide_follow_up_enabled = res.webguide_follow_up_enabled, webguide_follow_up_interval = res.webguide_follow_up_interval;
        setFollowupEnabled(webguide_follow_up_enabled);
        setFollowupDelay(webguide_follow_up_interval);
        setFollowUpMessage(convertResponseFromGetAPI(webguide_follow_up_msgs));
    };
    react_1["default"].useEffect(function () {
        var _a, _b;
        setLoading(true);
        DomainActions_1.getDomainData((_b = (_a = CommonStore_1["default"].getMetaTags()) === null || _a === void 0 ? void 0 : _a.domain) === null || _b === void 0 ? void 0 : _b.id).then(function (res) {
            if (res) {
                dispatcher_1.dispatch(MogamboConstants_2.ActionTypes.SET_CURRENT_BOT_SETTINGS, {
                    settings: res,
                });
            }
        });
        DomainAPI_1.getFollowupMessage(botId).then(function (res) {
            var _a;
            setLoading(false);
            if ((_a = res === null || res === void 0 ? void 0 : res.response) === null || _a === void 0 ? void 0 : _a.body) {
                var _b = res.response.body, webguide_follow_up_msgs = _b.webguide_follow_up_msgs, train_url = _b.train_url, zipFolderLink = _b.zip_folder_link, zipFolderValidated = _b.is_zip_folder_validated, zipFolderSavedByEmail = _b.zip_folder_saved_by;
                if (webguide_follow_up_msgs)
                    setFollowUpMessageResponse(res.response.body);
                if (train_url)
                    setTrainingUrl(train_url);
                if (zipFolderLink)
                    setZipFolderUrl(zipFolderLink);
                setSavedZipFolderLink(zipFolderLink);
                setIsZipFolderValidated(zipFolderValidated);
                setZipFolderSavedBy(zipFolderSavedByEmail);
            }
        });
        setAllLanguages(CommonStore_1["default"].getAllHybridLanguages());
    }, []);
    var showChannelChangeError = function () {
        var _a;
        var defaultVariants = ((_a = followUpMessage === null || followUpMessage === void 0 ? void 0 : followUpMessage[currentLanguageCode + "|" + currentHybridLanguageCode]) === null || _a === void 0 ? void 0 : _a[constants_1.DEFAULTS.CHANNEL_ID]) || [];
        return ((!followupMessageResponseSaved &&
            currentChannelId === constants_1.DEFAULTS.CHANNEL_ID) ||
            defaultVariants.length === 0);
    };
    var setFollowUpMessageData = function (val, channelId) {
        var _a, _b;
        var _c;
        var copyFollowUpMessage = JSON.parse(JSON.stringify(followUpMessage));
        if ((_c = copyFollowUpMessage === null || copyFollowUpMessage === void 0 ? void 0 : copyFollowUpMessage[currentLanguageCode + "|" + currentHybridLanguageCode]) === null || _c === void 0 ? void 0 : _c[channelId]) {
            copyFollowUpMessage[currentLanguageCode + "|" + currentHybridLanguageCode][channelId] = val;
        }
        else if (copyFollowUpMessage === null || copyFollowUpMessage === void 0 ? void 0 : copyFollowUpMessage[currentLanguageCode + "|" + currentHybridLanguageCode]) {
            copyFollowUpMessage[currentLanguageCode + "|" + currentHybridLanguageCode][channelId] = val;
        }
        else {
            copyFollowUpMessage = (_a = {},
                _a[currentLanguageCode + "|" + currentHybridLanguageCode] = (_b = {},
                    _b[channelId] = val,
                    _b),
                _a);
        }
        if (val.length === 0 && channelId !== constants_1.DEFAULTS.CHANNEL_ID) {
            delete copyFollowUpMessage[currentLanguageCode + "|" + currentHybridLanguageCode][channelId];
            if (platformIdsPresent.includes(channelId.toString())) {
                setPlatformIdsPresent(function (platforms) {
                    return platforms.filter(function (platform) { return platform !== channelId.toString(); });
                });
            }
        }
        setFollowUpMessage(copyFollowUpMessage);
    };
    var getTranslationsData = function (id) {
        var _a, _b, _c;
        var testConfigData = store_1["default"].getTestConfigData();
        var domainName = (_b = (_a = CommonStore_1["default"].getMetaTags()) === null || _a === void 0 ? void 0 : _a.domain) === null || _b === void 0 ? void 0 : _b.title;
        var payload = {
            followUpMessage: {
                variants: (_c = followUpMessage === null || followUpMessage === void 0 ? void 0 : followUpMessage[currentLanguageCode + "|" + currentHybridLanguageCode]) === null || _c === void 0 ? void 0 : _c[constants_1.DEFAULTS.CHANNEL_ID],
            },
            target_device_platform_id: Number(id),
            business_id: Number(businessIdentifier),
            client_id: testConfigData === null || testConfigData === void 0 ? void 0 : testConfigData.partner_client_id,
            domain_name: domainName,
        };
        setTranslateLoading(true);
        DomainAPI_1.getTranslations(payload).then(function (_a) {
            var _b, _c;
            var success = _a.success, response = _a.response;
            if (success && ((_c = (_b = response === null || response === void 0 ? void 0 : response.body) === null || _b === void 0 ? void 0 : _b.followUpMessage) === null || _c === void 0 ? void 0 : _c.variants)) {
                setFollowUpMessageData(response.body.followUpMessage.variants, response.body.target_device_platform_id.toString());
            }
            setTranslateLoading(false);
        });
    };
    var handleOCDropdownChange = function (id, name, validationRequire) {
        if (validationRequire === void 0) { validationRequire = true; }
        if (showChannelChangeError() && validationRequire) {
            BotActions_1.createAlert('Please save Follow-up messages in WebSDK to proceed.', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
        }
        else {
            if (!platformIdsPresent.includes(id.toString())) {
                getTranslationsData(id);
            }
            setCurrentChannelId(id.toString());
            setCurrentChannelName(name);
        }
    };
    var onChange = function (val) {
        setFollowUpMessageData(val, currentChannelId);
        if (val.length !== 0 &&
            !platformIdsPresent.includes(currentChannelId.toString())) {
            setPlatformIdsPresent(function (platFormIds) { return __spreadArrays(platFormIds, [
                currentChannelId.toString(),
            ]); });
        }
        setIsEdit(true);
        setFollowupMessageResponseSaved(false);
    };
    var showMissingInfoPopup = function () {
        dispatcher_1.dispatch(MogamboConstants_2.ActionTypes.OPEN_CONFIRMATION_DIALOG, {
            callback: function () {
            },
            title: 'AISS - Missing Information',
            message: (react_1["default"].createElement(StyledComponets_1.WarningBox, { isError: true },
                react_1["default"].createElement(StyledComponets_1.StyledUl, null,
                    react_1["default"].createElement("li", null, "To ensure AISS works correctly, please provide the \"Company Name\" and \"Company Description\"."),
                    react_1["default"].createElement("li", null, "You can add these details in \"Bot Settings > Advanced Options\".")))),
        });
    };
    var saveData = function (platformIdsPresent) {
        var _a, _b;
        var allDevices = [];
        var allVariants = [];
        var devicePlatformMap = {};
        if (Object.keys(followUpMessage).length !== 0) {
            var languageVariants_1 = JSON.parse(JSON.stringify(followUpMessage[currentLanguageCode + "|" + currentHybridLanguageCode]));
            var variantsMapNumber_1 = 0;
            Object.entries(languageVariants_1).forEach(function (_a) {
                var device = _a[0], _b = _a[1], variants = _b === void 0 ? [] : _b;
                if (!platformIdsPresent.includes(device.toString())) {
                    delete languageVariants_1[device.toString()];
                }
            });
            Object.entries(languageVariants_1).forEach(function (_a) {
                var device = _a[0], _b = _a[1], variants = _b === void 0 ? [] : _b;
                allDevices.push(device);
                allVariants = __spreadArrays(allVariants, variants);
                if (variants.length !== 0) {
                    devicePlatformMap[device] = [];
                    for (var i = variantsMapNumber_1; i < variantsMapNumber_1 + variants.length; i++)
                        devicePlatformMap[device].push(i);
                    variantsMapNumber_1 += variants.length;
                }
            });
        }
        var _c = CommonStore_1["default"].getCurrentBotSettings().bot_properties, botProperties = _c === void 0 ? {} : _c;
        var companyDescription = (_a = botProperties === null || botProperties === void 0 ? void 0 : botProperties.company_context) === null || _a === void 0 ? void 0 : _a.trim();
        var replyTagsObject = (botProperties === null || botProperties === void 0 ? void 0 : botProperties.reply_tags) || {};
        var languageCode = Object.keys(replyTagsObject)[0];
        var replyTags = replyTagsObject[languageCode] || {};
        var companyName = (_b = replyTags['%company']) === null || _b === void 0 ? void 0 : _b.trim();
        if ((trainingUrl || zipFolderUrl) && (!companyDescription || !companyName)) {
            showMissingInfoPopup();
            return;
        }
        if (trainingUrl && utils_2.isNotAValidUrl(trainingUrl)) {
            BotActions_1.createAlert('Invalid URL: Please enter valid training sheet URL.', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        if (zipFolderUrl && utils_2.isNotAValidUrl(zipFolderUrl)) {
            BotActions_1.createAlert('Invalid URL: Please enter valid zip folder URL.', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var postData = {
            webguide_follow_up_msgs: {
                device_platform_map: devicePlatformMap,
                quick_replies: [],
                variants: allVariants,
                lang_src: currentLanguageCode,
                lang_script: currentHybridLanguageCode,
            },
            train_url: trainingUrl,
            zip_folder_link: zipFolderUrl,
            webguide_follow_up_interval: followupDelay,
            webguide_follow_up_enabled: followupEnabled,
        };
        setLoading(true);
        DomainAPI_1.saveFollowupMessage(botId, postData).then(function (res) {
            var _a, _b, _c;
            if (res.success) {
                setLoading(false);
                if ((_a = res === null || res === void 0 ? void 0 : res.response) === null || _a === void 0 ? void 0 : _a.body) {
                    var _d = res.response.body, webguide_follow_up_msgs = _d.webguide_follow_up_msgs, webguide_follow_up_interval = _d.webguide_follow_up_interval, webguide_follow_up_enabled = _d.webguide_follow_up_enabled, is_zip_folder_validated = _d.is_zip_folder_validated, zip_folder_saved_by = _d.zip_folder_saved_by, zip_folder_link = _d.zip_folder_link;
                    setPlatformIdsPresent([]);
                    setFollowupEnabled(webguide_follow_up_enabled);
                    setFollowupDelay(webguide_follow_up_interval);
                    setFollowUpMessage(convertResponseFromGetAPI(webguide_follow_up_msgs));
                    setIsZipFolderValidated(is_zip_folder_validated);
                    setZipFolderSavedBy(zip_folder_saved_by);
                    if (!platformIdsPresent.includes(currentChannelId.toString())) {
                        getTranslationsData(currentChannelId);
                    }
                    if (zip_folder_link && zip_folder_link !== savedZipFolderLink)
                        setDocumentsUploading(true);
                    setSavedZipFolderLink(zip_folder_link);
                    setZipFolderUrl(zip_folder_link);
                    BotActions_1.createAlert('Changes saved successfully!', 3000, MogamboConstants_1.AlertTypes.POSITIVE);
                    setIsEdit(false);
                    setFollowupMessageResponseSaved(true);
                }
                else if ((_b = res === null || res === void 0 ? void 0 : res.response) === null || _b === void 0 ? void 0 : _b.error) {
                    setLoading(false);
                    BotActions_1.createAlert(res.response.error, 4000, MogamboConstants_1.AlertTypes.NEGATIVE);
                }
            }
            else {
                setLoading(false);
                BotActions_1.createAlert(((_c = res === null || res === void 0 ? void 0 : res.response) === null || _c === void 0 ? void 0 : _c.error) || 'Something went wrong.', 4000, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
        });
    };
    var handleSave = function () {
        // If WebSDK does not contain variants
        var _a;
        if (!followupEnabled) {
            saveData(platformIdsPresent);
        }
        else if ((_a = followUpMessage === null || followUpMessage === void 0 ? void 0 : followUpMessage[currentLanguageCode + "|" + currentHybridLanguageCode]) === null || _a === void 0 ? void 0 : _a[constants_1.DEFAULTS.CHANNEL_ID]) {
            var webVariants = __spreadArrays(followUpMessage[currentLanguageCode + "|" + currentHybridLanguageCode][constants_1.DEFAULTS.CHANNEL_ID]);
            if (webVariants.length === 0) {
                BotActions_1.createAlert('Follow-up Messages cannot be left empty. In case they are not needed, kindly switch them OFF', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
            else {
                saveData(platformIdsPresent);
            }
        }
        else {
            BotActions_1.createAlert('Follow-up Messages cannot be left empty. In case they are not needed, kindly switch them OFF', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
        }
    };
    var handleToggle = function (value) {
        setFollowupEnabled(value);
        setIsEdit(true);
    };
    var handleFollowUpMessage = function (e) {
        setFollowupDelay(e.target.valueAsNumber);
        setIsEdit(true);
    };
    var handleTrainingUrl = function (value) {
        setTrainingUrl(value);
        setIsEdit(true);
    };
    var handleZipFolderUrl = function (value) {
        setZipFolderUrl(value);
        setIsEdit(true);
    };
    var handleReset = function () {
        var _a;
        var copyPlatFormIdsPresent = __spreadArrays(platformIdsPresent).filter(function (platform) { return platform !== currentChannelId.toString(); });
        var currentDpsvChannels = (dpsvChannels === null || dpsvChannels === void 0 ? void 0 : dpsvChannels[currentLanguageCode + "|" + currentHybridLanguageCode]) ||
            {};
        setPlatformIdsPresent(copyPlatFormIdsPresent);
        setDpsvChannels(__assign(__assign({}, dpsvChannels), (_a = {}, _a[currentLanguageCode + "|" + currentHybridLanguageCode] = currentDpsvChannels.filter(function (platform) { return platform !== currentChannelId.toString(); }), _a)));
        saveData(copyPlatFormIdsPresent);
    };
    react_1["default"].useEffect(function () {
        var languageKey = currentLanguageCode + "|" + currentHybridLanguageCode;
        setPlatformIdsPresent((dpsvChannels === null || dpsvChannels === void 0 ? void 0 : dpsvChannels[languageKey]) || []);
    }, [currentLanguageCode, currentHybridLanguageCode, dpsvChannels]);
    return (react_1["default"].createElement(WebGuide_1["default"], { currentChannelId: currentChannelId, handleOCDropdownChange: handleOCDropdownChange, value: ((_a = followUpMessage === null || followUpMessage === void 0 ? void 0 : followUpMessage[currentLanguageCode + "|" + currentHybridLanguageCode]) === null || _a === void 0 ? void 0 : _a[currentChannelId]) || [], currentLanguageCode: currentLanguageCode, isTranslateLoading: translateLoading, onChange: onChange, webSDKSaved: showChannelChangeError(), onSave: handleSave, followupEnabled: followupEnabled, handleToggle: handleToggle, handleFollowUpMessage: handleFollowUpMessage, followupDelay: followupDelay, isEdit: isEdit, disabled: utils_1.isProduction(), trainingUrl: trainingUrl, zipFolderUrl: zipFolderUrl, isZipFolderValidated: isZipFolderValidated, zipFolderSavedBy: zipFolderSavedBy, savedZipFolderLink: savedZipFolderLink, onChangeTrainingUrl: handleTrainingUrl, onZipFolderUrlChange: handleZipFolderUrl, documentsUploading: documentsUploading, setDocumentsUploading: setDocumentsUploading, loading: loading, platformIdsPresent: dpsvChannels[currentLanguageCode + "|" + currentHybridLanguageCode], currentChannelName: currentChannelName, handleReset: handleReset, allLanguages: allLanguages, setCurrentLanguage: setCurrentLanguageCode, currentHybridLanguage: currentHybridLanguageCode, setCurrentHybridLanguage: setCurrentHybridLanguageCode, isFollowupMessageEdited: !followupMessageResponseSaved, showMissingInfoPopup: showMissingInfoPopup }));
};
exports["default"] = WebGuideSwitch;
